export default __webpack_public_path__ + "static/media/TECHNOLOGIA.339219d6.png";